import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, Icons, Tooltip } from 'baukasten';

import messages from './messages';

type Props = { text: string };

export const CopyAnswerButton = ({ text }: Props) => {
  const { formatMessage } = useIntl();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const label = formatMessage(
    copied ? messages.answerCopied : messages.copyAnswer
  );

  return (
    <Tooltip tooltipContent={label}>
      <Button
        type="button"
        variant="text"
        size="s"
        aria-label={label}
        startIcon={copied ? Icons.Check : Icons.Copy}
        onClick={copy}
      />
    </Tooltip>
  );
};
